export const DESIRE_RATIO       /**/ = 0.0666 as const;
export const DESIRE_RATIO_D_4   /**/ = 0.0167 as const;
export const DESIRE_RATIO_D_3   /**/ = 0.0222 as const;
export const DESIRE_RATIO_D_2   /**/ = 0.0333 as const;
export const DESIRE_RATIO_X_1   /**/ = 0.0666 as const;
export const DESIRE_RATIO_X_2   /**/ = 0.1665 as const;
export const DESIRE_RATIO_X_3   /**/ = 0.1998 as const;
export const DESIRE_RATIO_X_4   /**/ = 0.2664 as const;

export const DESIRE_RATIO_X_1_5 /**/ = 0.0999 as const;
export const DESIRE_RATIO_X_2_5 /**/ = 0.1665 as const;
export const DESIRE_RATIO_X_3_5 /**/ = 0.2331 as const;
